module.exports = __webpack_public_path__ + "static/media/bicycle.3b7be915.svg";